import React from 'react';
import { useTranslation } from 'react-i18next';
import '../cpdpro.css';

export default function CpdProAccreditatiePage() {
  const { t } = useTranslation();

  return (
    <>
      <section className="cpd-page-hero">
        <div className="container">
          <h1>{t('cpd.accreditatie.title', 'Accreditatie')}</h1>
          <p className="muted">
            {t('cpd.accreditatie.subtitle', 'For most professionals, accreditation is a requirement—not a nice-to-have.')}
          </p>
        </div>
      </section>

      <section className="cpd-accreditation">
        <div className="container">
          <div className="accreditation-card">
            <div className="accreditation-left">
              <div className="label">{t('cpd.accreditatie.accreditedBy', 'Accredited by')}</div>
              <img src="/NIRV-logo-kleur.png" alt="NiRV" className="nirv-logo" />
            </div>
            <div className="accreditation-right">
              <ul>
                <li>{t('cpd.accreditatie.b1', 'Verifiable certificate IDs')}</li>
                <li>{t('cpd.accreditatie.b2', 'Instant downloadable certificates')}</li>
                <li>{t('cpd.accreditatie.b3', 'Clear history and reporting for audits')}</li>
              </ul>
            </div>
          </div>

          <div className="accreditation-grid">
            <div className="accreditation-item">
              <h3>{t('cpd.accreditatie.i1.title', 'Audit-ready')}</h3>
              <p>{t('cpd.accreditatie.i1.desc', 'Every certificate includes an ID + verification link for fast validation.')}</p>
            </div>
            <div className="accreditation-item">
              <h3>{t('cpd.accreditatie.i2.title', 'Reliable evidence')}</h3>
              <p>{t('cpd.accreditatie.i2.desc', 'Your dashboard keeps your completions, points, and certificates organized.')}</p>
            </div>
            <div className="accreditation-item">
              <h3>{t('cpd.accreditatie.i3.title', 'Simple for institutions')}</h3>
              <p>{t('cpd.accreditatie.i3.desc', 'Share certificates individually or as a combined bundle when needed.')}</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}


